import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../Components/base/sidebar";
import ActionBar from "../../../Components/Button/ActionBar";
import SEOForm from "../../../Components/Forms/SEOForm";
import Delete from "../../../Components/Button/Delete";
import StoryDetails from "../../../Components/Forms/StoryDetails";
import BuyLinkForm from "../../../Components/Forms/BuyLinkForm";

interface Item {
  ticket_id: number;
  ticket_group_code: string;
  // Add more properties as per your item structure
}

export default function TicketPricesEditor() {
  const location = useLocation();
  const id = location.state && location.state.id;
  const [button_name, setButtonName] = useState("");
  const [url, setUrl] = useState("");
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [items, setItems] = useState<Item[]>([]);
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      fetchItem(id);
    }
  }, [id]);

  const handleTicketGroupCodeChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setTicketGroupCode(e.target.value);
  };

  const handleButtonNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setButtonName(e.target.value);
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  };

  const navigate = useNavigate();

  const fetchItems = async () => {
    try {
      const response = await axios.get(
        "https://cdn.pulp.ph/api/v1/pulpliveworld/ticket",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setItems(response.data.ticket);
    } catch (error) {
      console.error("Error Fetching items:", error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItem = async (id: number) => {
    try {
      const response = await axios.get(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      ); // Fetch item based on ID
      const ticket = response.data.ticket;
      if (ticket) {
        const { button_name, url, ticket_group_code, ticket_id } = ticket;
        setItem(ticket);
        setButtonName(button_name);
        setUrl(url);
        setTicketGroupCode(ticket_group_code);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    formData.append("button_name", button_name);
    formData.append("url", url);
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      alert("Content Submitted Successfully !!"); // Handle success (e.g., show a success message or redirect)
      navigate("/view/post/buy-links");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`There was an error submitting the form!, ${error}`);
      // Handle error (e.g., show an error message)
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     setIsSaved(true);

  //     const formData = new FormData();
  //     formData.append('ticket_group_code', ticket_group_code);
  //     formData.append('tier', tier);
  //     formData.append('currency', currency);
  //     formData.append('amount', amount);
  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             // Handle the case where authToken is not available
  //             alert('Authentication token not found!');
  //             setIsSubmitting(false);
  //             return;
  //         }

  //         await axios.post(`https://cdn.pulp.ph/api/v1/community/save/${id}`, formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data',
  //                 Authorization: `Bearer ${authToken}`,
  //             }
  //         });
  //         alert('Draft Saved Successfully !!'); // Handle success (e.g., show a success message or redirect)
  //         navigate('/view/post/ticket-prices');
  //     } catch (error) {
  //         console.error('There was an error submitting the form!', error);
  //         alert(`There was an error submitting the form!, ${error}`);
  //         // Handle error (e.g., show an error message)
  //     } finally {
  //         setTimeout(() => {
  //             setIsSaved(false);
  //         }, 3000);
  //     }
  // };

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(
          `https://cdn.pulp.ph/api/v1/pulpliveworld/buy-link/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
      }
      alert("Content Deleted Successfully !!");
      navigate("/view/post/buy-link");
    } catch (error) {
      console.error("There was an error deleting the content!", error);
      alert(`There was an error deleting the content!, ${error}`);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const handleViewShortstory = () => {
    window.open(`https://pulpmagazine.com/article/${id}`, "_blank");
  };

  return (
    <>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h1 className="mt-5 font-semibold">Buy Link Editor</h1>
          <ActionBar
            role={role}
            onSubmit={handleSubmit}
            onView={handleViewShortstory}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>
        <div className="container mt-5 pt-5 px-4 rounded bg-white">
          <BuyLinkForm
            ticket_group_code={ticket_group_code}
            items={items}
            button_name={button_name}
            url={url}
            onTicketGroupCodeChange={handleTicketGroupCodeChange}
            onButtonNameChange={handleButtonNameChange}
            onUrlChange={handleUrlChange}
          />
        </div>
      </div>
    </>
  );
}
